import { EventDispatcher } from "../events/EventDispatcher";
import { PAL } from "./PlatformAdapters";
export class DeviceAdapter extends EventDispatcher {
    get supportedLocation() {
        return false;
    }
    get supportedGetUserMedia() {
        return false;
    }
    getCurrentPosition(successCallback, errorCallback, options) {
    }
    watchPosition(successCallback, errorCallback, options) {
        return -1;
    }
    clearWatchPosition(id) {
    }
    getUserMedia(constraints, successCallback, errorCallback) {
    }
    onStartListeningToType(type) {
        if (type === "devicemotion")
            this.startListeningDeviceMotion();
        else if (type === "deviceorientation")
            this.startListeningDeviceOrientation();
        return this;
    }
    startListeningDeviceMotion() {
    }
    startListeningDeviceOrientation() {
    }
}
PAL.register("device", DeviceAdapter);
